import { categories, siteName } from '@/mocks/manga';

const navLinks = [
  { key: 'hero', label: '首页' },
  { key: 'categories', label: '分类导航' },
  { key: 'hot', label: '热门推荐' },
  { key: 'featured', label: '编辑精选' },
  { key: 'faq', label: '常见问题' },
  { key: 'about', label: '关于我们' },
];

export default function Footer() {
  const goTo = (key: string) => {
    const el = document.getElementById(key);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="bg-gradient-to-br from-primary-800 to-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-primary-700">
                <i className="ri-sparkling-2-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200/80">
              专注女神系漫画的在线阅读推荐与分类导航，帮你找到值得一读的每一部作品。
            </p>
            <div className="mt-5 flex gap-3">
              {['ri-qq-fill', 'ri-wechat-fill', 'ri-weibo-fill', 'ri-mail-fill'].map((ic) => (
                <a
                  key={ic}
                  href="#hero"
                  onClick={(e) => {
                    e.preventDefault();
                    goTo('hero');
                  }}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-background-50 hover:text-primary-700"
                  aria-label="社交媒体链接"
                >
                  <i className={`${ic} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">
              快速导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.key}>
                  <button
                    type="button"
                    onClick={() => goTo(l.key)}
                    className="cursor-pointer text-sm text-background-200/80 transition-colors hover:text-background-50"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">
              题材分类
            </h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.key}>
                  <button
                    type="button"
                    onClick={() => goTo('hot')}
                    className="cursor-pointer text-sm text-background-200/80 transition-colors hover:text-background-50"
                  >
                    {c.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">
              联系我们
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" />
                contact@nvshenmanhua.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-3-line" />
                欢迎反馈想看的新题材
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line" />
                每日更新热门推荐
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 text-xs text-background-200/60 sm:flex-row">
          <p>© {new Date().getFullYear()} {siteName} · 专注于女神系漫画推荐</p>
          <p>内容仅作整理推荐，请以作品官方渠道为准</p>
        </div>
      </div>
    </footer>
  );
}